<template>
  <div class="scrutinio">
    <div class="back">
      <router-link
        @click="backButtonClicked = true"
        :to="{
          name: 'group',
          params: { locale: $route.params.locale, pagination: page }
        }"
        tag="button"
        class="md-button md-theme-default button-link"
        >&lt; {{ $t("scrutinio.back-button") }}</router-link
      >
    </div>
    <div class="overlay" v-if="loading">
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="10"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="error" v-if="errorInProgress">
      <span>{{ $t("ballot.state.in-error") }}</span>
    </div>

    <div class="info" v-if="!final && report">
      <h3 class="loading">{{ $t("ballot.state.in-progress") }}</h3>
      <span class="loading percentage"
        >{{ $t("ballot.state.loading") }} <b>{{ completedPerc }}%</b>
      </span>
      <span class="loading"></span>
    </div>
    <md-progress-bar
      v-if="!final && report"
      md-mode="determinate"
      :md-value="completedPerc"
      :class="{ 'completed-perc': completedPerc >= 50 }"
    ></md-progress-bar>

    <!-- controllare se è ancora in corso uno scrutinio generale e se c'è una prossima elezione -->
    <div
      class="info completed"
      v-if="final && $store.state.electionMode == 'SEQ' && !errorInProgress"
    >
      <h3>{{ $t("ballot.state.done") }}</h3>
      <a
        v-if="
          pollStatus.ON_WAITING > 0 &&
            pollStatus.IN_PROGRESS == 0 &&
            showContinueLink
        "
        @click="next()"
        >{{ $t("group.count") }}
        <b>{{ currentCountingTaskDone }}</b>
        {{ $t("group.count-over") }}
        <b>{{ currentCountingTaskId }}</b>
        {{ $t("group.count-over-elections-selected") }}.
        {{ $t("scrutinio.next-election-link") }}</a
      >
    </div>

    <h1 class="scrutinio-title">{{ name }}</h1>

    <md-card>
      <div v-if="report">
        <!-- Tabella Risultati  -->
        <md-table v-model="report" class="myTable">
          <md-table-toolbar>
            <h1 class="md-title">
              <b>{{ $t("scrutinio.table.title") }}</b>
            </h1>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              :md-label="$t('scrutinio.table.position')"
              width="20%"
              >{{ item.pos }}</md-table-cell
            >
            <md-table-cell
              :md-label="
                nameLabel()
                  ? $t('scrutinio.table.nameCand')
                  : $t('scrutinio.table.nameList')
              "
            >
              <span
                v-if="
                  electionType == 'UNGROUPED_ONLY_CANDIDATES' ||
                    electionType ==
                      'UNGROUPED_ONLY_CANDIDATES_GROUP_AND_ELECTIONS'
                "
                >{{ item.CountedCandidate.CandidateIdentifier.CandidateName }}
                <span v-if="item.CountedCandidate.CandidateIdentifier.KnownAs"
                  >({{
                    item.CountedCandidate.CandidateIdentifier.KnownAs
                  }})</span
                ></span
              >
              <span
                v-if="
                  electionType == 'UNGROUPED_ONLY_AFFILIATIONS' ||
                    electionType == 'UNGROUPED_AFFILIATIONS_AND_CANDIDATES'
                "
                >{{
                  item.CountedAffiliation.AffiliationIdentifier.RegisteredName
                }}</span
              >
            </md-table-cell>
            <md-table-cell :md-label="$t('scrutinio.table.votes')" width="10%">
              <span
                v-if="
                  electionType == 'UNGROUPED_ONLY_CANDIDATES' ||
                    electionType ==
                      'UNGROUPED_ONLY_CANDIDATES_GROUP_AND_ELECTIONS'
                "
                >{{ item.CountedCandidate.ValidVotes }}</span
              >
              <span
                v-if="
                  electionType == 'UNGROUPED_ONLY_AFFILIATIONS' ||
                    electionType == 'UNGROUPED_AFFILIATIONS_AND_CANDIDATES'
                "
                >{{ item.CountedAffiliation.ValidVotes }}</span
              ></md-table-cell
            >
          </md-table-row>
        </md-table>
      </div>
      <div v-if="showEmpty" class="empty">
        {{ $t("scrutinio.report.no-preferences") }}
      </div>

      <div v-if="report || showEmpty">
        <!-- Risultati riassunto -->
        <md-table class="myTable tableTotalVotes" v-if="totalVotes">
          <md-table-row>
            <md-table-cell style="text-align: right">{{
              $t("scrutinio.report.blank-ballots")
            }}</md-table-cell>
            <md-table-cell width="10%">{{
              totalVotes.BlankBallots
            }}</md-table-cell>
          </md-table-row>
          <md-table-row v-if="totalVotes.NullBallots">
            <md-table-cell style="text-align: right">{{
              $t("scrutinio.report.null-ballots")
            }}</md-table-cell>
            <md-table-cell width="10%">
              {{ totalVotes.NullBallots }}</md-table-cell
            >
          </md-table-row>
          <md-table-row
            v-if="
              totalVotes.UncountedBallots && totalVotes.UncountedBallots > 0
            "
          >
            <md-table-cell style="text-align: right; color: orangered"
              >{{ $t("scrutinio.report.uncounted-ballots") }}
            </md-table-cell>
            <md-table-cell width="10%" style="color: orangered">
              {{ totalVotes.UncountedBallots }}</md-table-cell
            >
          </md-table-row>
          <md-table-row>
            <md-table-cell></md-table-cell><md-table-cell></md-table-cell
          ></md-table-row>

          <md-table-row>
            <md-table-cell style="text-align: right">
              <b>{{ $t("scrutinio.report.total-counted") }}</b></md-table-cell
            >
            <md-table-cell width="10%">
              <b> {{ totalVotes.TotalCounted }}</b></md-table-cell
            >
          </md-table-row>
          <md-table-row v-if="totalVotes.Abstentions">
            <md-table-cell style="text-align: right">
              {{ $t("scrutinio.report.abstensions") }}</md-table-cell
            >
            <md-table-cell width="10%">
              <b> {{ totalVotes.Abstentions }}</b></md-table-cell
            >
          </md-table-row>
          <md-table-row v-if="totalVotes.RegisteredVoters">
            <md-table-cell style="text-align: right">
              {{ $t("scrutinio.report.registered-voters") }}</md-table-cell
            >
            <md-table-cell width="10%">
              {{ totalVotes.RegisteredVoters }}</md-table-cell
            >
          </md-table-row>
        </md-table>
      </div>
    </md-card>

    <div v-if="final">
      <!-- Tabella singole liste  -->
      <div v-if="electionType == 'UNGROUPED_AFFILIATIONS_AND_CANDIDATES'">
        <md-card v-for="list in report" :key="list.pos">
          <md-table
            v-if="list.CountedAffiliation.CountedCandidate"
            v-model="list.CountedAffiliation.CountedCandidate"
            class="myTable listTable"
          >
            <md-table-toolbar>
              <h1 class="md-title">
                <b
                  >{{ $t("scrutinio.report-final.title") }}
                  {{
                    list.CountedAffiliation.AffiliationIdentifier.RegisteredName
                  }}</b
                >
              </h1>
            </md-table-toolbar>
            <div
              v-if="
                list.CountedAffiliation.CountedCandidate == null ||
                  list.CountedAffiliation.CountedCandidate.length == 0
              "
              class="empty"
            >
              {{ $t("scrutinio.report.no-preferences") }}
            </div>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                :md-label="$t('scrutinio.table.position')"
                width="20%"
                >{{ item.pos }}</md-table-cell
              >
              <md-table-cell :md-label="$t('scrutinio.table.nameCand')">
                {{ item.CandidateIdentifier.CandidateName }}
                <span v-if="item.CandidateIdentifier.KnownAs"
                  >({{ item.CandidateIdentifier.KnownAs }})</span
                >
              </md-table-cell>
              <md-table-cell
                :md-label="$t('scrutinio.table.votes')"
                width="10%"
              >
                {{ item.ValidVotes }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card>
      </div>

      <!-- Tabella voto pesato  -->
      <div
        v-if="
          electionType == 'UNGROUPED_ONLY_CANDIDATES_GROUP_AND_ELECTIONS' &&
            groups
        "
      >
        <md-card v-for="list in groups" :key="list.pos">
          <md-table
            v-model="list.TotalVotes.Selection"
            class="myTable listTable"
            v-if="list.CountQualifier"
          >
            <md-table-toolbar>
              <h1 class="md-title">
                <b
                  >{{ $t("scrutinio.report-final.title") }}
                  {{ list.ContestIdentifier.ContestName }}</b
                >
              </h1>
            </md-table-toolbar>
            <div
              v-if="
                list.TotalVotes.Selection == null ||
                  list.TotalVotes.Selection.length == 0
              "
              class="empty"
            >
              {{ $t("scrutinio.report.no-preferences") }}
            </div>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                :md-label="$t('scrutinio.table.position')"
                width="20%"
                >{{ item.pos }}</md-table-cell
              >
              <md-table-cell :md-label="$t('scrutinio.table.nameCand')">
                {{ item.CountedCandidate.CandidateIdentifier.CandidateName }}
                <span v-if="item.CountedCandidate.CandidateIdentifier.KnownAs"
                  >({{
                    item.CountedCandidate.CandidateIdentifier.KnownAs
                  }})</span
                >
              </md-table-cell>
              <md-table-cell
                :md-label="$t('scrutinio.table.votes')"
                width="10%"
              >
                {{ item.CountedCandidate.ValidVotes }}
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- Risultati riassunto  voto pesato -->
          <md-table class="myTable tableTotalVotes" v-if="list.CountQualifier">
            <md-table-row>
              <md-table-cell style="text-align: right">{{
                $t("scrutinio.report.blank-ballots")
              }}</md-table-cell>
              <md-table-cell width="10%">{{
                list.TotalVotes.BlankBallots
              }}</md-table-cell>
            </md-table-row>
            <md-table-row v-if="list.TotalVotes.NullBallots">
              <md-table-cell style="text-align: right">{{
                $t("scrutinio.report.null-ballots")
              }}</md-table-cell>
              <md-table-cell width="10%">
                {{ list.TotalVotes.NullBallots }}</md-table-cell
              >
            </md-table-row>
            <md-table-row
              v-if="
                list.TotalVotes.UncountedBallots &&
                  list.TotalVotes.UncountedBallots > 0
              "
            >
              <md-table-cell style="text-align: right; color: orangered"
                >{{ $t("scrutinio.report.uncounted-ballots") }}
              </md-table-cell>
              <md-table-cell width="10%" style="color: orangered">
                {{ list.TotalVotes.UncountedBallots }}</md-table-cell
              >
            </md-table-row>
            <md-table-row>
              <md-table-cell></md-table-cell><md-table-cell></md-table-cell
            ></md-table-row>

            <md-table-row>
              <md-table-cell style="text-align: right">
                <b>{{ $t("scrutinio.report.total-counted") }}</b></md-table-cell
              >
              <md-table-cell width="10%">
                <b> {{ list.TotalVotes.TotalCounted }}</b></md-table-cell
              >
            </md-table-row>
            <md-table-row v-if="list.TotalVotes.Abstentions">
              <md-table-cell style="text-align: right">
                {{ $t("scrutinio.report.abstensions") }}</md-table-cell
              >
              <md-table-cell width="10%">
                <b> {{ list.TotalVotes.Abstentions }}</b></md-table-cell
              >
            </md-table-row>
            <md-table-row v-if="list.TotalVotes.RegisteredVoters">
              <md-table-cell style="text-align: right">
                {{ $t("scrutinio.report.registered-voters") }}</md-table-cell
              >
              <md-table-cell width="10%">
                {{ list.TotalVotes.RegisteredVoters }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </md-card>
      </div>
    </div>
    <passkey-dialog
      v-if="openPassModal"
      :openPassModal="openPassModal"
      @cancel="openPassModal = false"
      @okPasskey="iniziaScrutinio($event)"
    ></passkey-dialog>
  </div>
</template>

<script>
// import store from "../store";
import PasskeyDialog from "./PasskeyDialog.vue";

export default {
  async mounted() {
    this.$emit("startLoading");
    await this.getReport();
    // scrolla per far vedere lo scrutinio in sequenza
    if (!this.final && this.$store.state.electionMode == "SEQ")
      window.scrollTo(0, 200);
  },
  updated() {
    // scrolla per far vedere lo scrutinio in sequenza quando si cambia elezione
    if (!this.final && this.$store.state.electionMode == "SEQ")
      window.scrollTo(0, 200);
  },
  data: function() {
    return {
      report: null,
      pos: 0,
      name: null,
      totalVotes: null,
      electionType: null,
      groups: null,
      showEmpty: false,
      final: false,
      pollInterval: 1000,
      openPassModal: false,
      hasNextGroupId: false,
      pollStatus: { DONE: 0, IN_PROGRESS: 0, ON_WAITING: 0, END: true },
      completedPerc: 0,
      backButtonClicked: false,
      checkStatusCalled: false,
      loading: false,
      inCountingTaskId: null,
      currentCountingTaskId: 0,
      currentCountingTaskDone: 0,
      showContinueLink: false,
      errorInProgress: false
    };
  },
  props: {
    id: {
      type: String,
      require: true
    },
    page: {
      type: String,
      require: false
    }
  },
  methods: {
    async getReport() {
      this.loading = true;
      let report = await this.$store.state.ceoCbbService.countingReport(
        this.id,
        this.inCountingTaskId
      );

      if (report.error) {
        alert(report.error);
        return;
      }

      if (report.Count != null) {
        if (report.Count.CountedElectionGroup != null) {
          //console.log("getReport count != null");
          this.electionType =
            report.Count.CountedElectionGroup[0].Contests.Contest[0].CountingAlgorithm;
          this.totalVotes =
            report.Count.CountedElectionGroup[0].Contests.Contest[0].TotalVotes;
          this.report =
            this.totalVotes.Selection == null ? [] : this.totalVotes.Selection;
          this.final =
            report.Count.CountQualifier.Final == "yes" ? true : false;
          this.name = report.Count.CountedElectionGroup[0].ElectionGroup.Name;
          this.completedPerc = Math.round(
            (report.CountingFragment / report.NumOfFragments) * 100
          );
        } else {
          this.final = true;
        }
        this.$emit("stopLoading");

        //console.log("report", report);

        if (this.report) {
          if (this.report.length == 0) {
            this.showEmpty = true;
          }
          this.calcoloPosizione(report);
        } else {
          //Non dovremmo mai capitarci
          this.showEmpty = true;
        }

        // errore durante lo scrutinio
        if (report.CountingTaskStatus == "ERROR") {
          this.loading = false;
          this.errorInProgress = true;
          this.final = true;
        }

        // this.$emit("stopLoading");

        //se non è conclusa la votazione parte il polling
        if (!this.final) this.poll(this.pollInterval);
        else this.loading = false;
      } else {
        this.final = false;
        this.completedPerc = 0;
        this.$emit("stopLoading");
        this.poll(this.pollInterval);
      }
      this.checkStatus();
    },
    async poll(ms) {
      while (!this.final && !this.backButtonClicked) {
        let results = await this.$store.state.ceoCbbService.countingReport(
          this.id,
          this.inCountingTaskId
        );

        if (results.Count != null) {
          this.loading = false;

          if (results.Count.CountedElectionGroup != null) {
            this.electionType =
              results.Count.CountedElectionGroup[0].Contests.Contest[0].CountingAlgorithm;
            this.totalVotes =
              results.Count.CountedElectionGroup[0].Contests.Contest[0].TotalVotes;
            this.report =
              this.totalVotes.Selection == null
                ? []
                : this.totalVotes.Selection;
            this.final =
              results.Count.CountQualifier.Final == "yes" ? true : false;
            this.name =
              results.Count.CountedElectionGroup[0].ElectionGroup.Name;
            if (results.NumOfFragments == 0) {
              this.completedPerc = 100;
            } else {
              this.completedPerc = Math.round(
                (results.CountingFragment / results.NumOfFragments) * 100
              );
            }
          } else {
            this.final = true;
          }

          if (!this.checkStatusCalled) {
            this.checkStatus();
            this.checkStatusCalled = true;
          }
          //console.log("results", results);
          if (this.report) {
            if (this.report.length == 0) this.showEmpty = true;
            this.calcoloPosizione(results);
          } else this.showEmpty = true; //Non dovremmo mai capitarci
        }

        // errore durante lo scrutinio
        if (results.CountingTaskStatus == "ERROR") {
          this.loading = false;
          this.$emit("stopLoading");
          this.errorInProgress = true;
          this.final = true;
        }

        await this.wait(ms);
      }
      this.checkStatus();

      // if (!this.report) this.showEmpty = true;
    },
    wait(ms = 1000) {
      return new Promise(resolve => {
        //console.log(`waiting ${ms} ms...`);
        this.timeout = setTimeout(resolve, ms);
      });
    },
    calcoloPosizione(report) {
      let i = 1;
      this.report.map(x => (x.pos = i++));
      if (this.final) {
        //calcolo la posizione dei candidati nelle singole liste
        if (this.electionType == "UNGROUPED_AFFILIATIONS_AND_CANDIDATES") {
          this.report.forEach(list => {
            i = 1;
            if (list.CountedAffiliation.CountedCandidate != null) {
              list.CountedAffiliation.CountedCandidate.map(x => (x.pos = i++));
            }
          });
        }

        //calcolo la posizione dei candidati pesati
        if (
          this.electionType == "UNGROUPED_ONLY_CANDIDATES_GROUP_AND_ELECTIONS"
        ) {
          this.groups = report.Count.CountedElectionGroup[0].Contests.Contest;
          this.groups.forEach(list => {
            if (list.TotalVotes.Selection == null) {
              list.TotalVotes.Selection = [];
            }
            i = 1;
            list.TotalVotes.Selection.map(x => (x.pos = i++));
          });
        }
      }
    },
    next() {
      //se la passkey non è memorizzata la chiediamo
      //this.$emit("startLoading");
      if (!this.$store.getters.getPassKey) this.openPassModal = true;
      else this.iniziaScrutinio(this.$store.getters.getPassKey);
    },
    async iniziaScrutinio(password) {
      this.report = null;
      this.final = false;
      this.checkStatusCalled = false;
      this.openPassModal = false;
      this.showEmpty = false;
      this.loading = true;
      this.showContinueLink = false;

      if (!this.$store.getters.getPassKey)
        this.$store.commit("passKeySetter", password);

      this.$emit("startLoading");

      const results = await this.$store.state.ceoCbbService.nextGroup(password);
      this.hasNextGroupId = results.NextGroupId ? true : false;

      if (results.GroupId) {
        this.$router
          .push({
            path: `/${this.$route.params.locale}/scrutinio/${results.GroupId}/1`
          })
          .catch(() => {});
      }
    },
    async checkStatus() {
      let results = await this.$store.state.ceoCbbService.countingStatus();
      this.inCountingTaskId = results.InCountingTaskId;
      results = results.GroupCountingStatusInfo;

      this.pollStatus = {
        DONE: 0,
        IN_PROGRESS: 0,
        ON_WAITING: 0,
        END: false
      };

      this.currentCountingTaskDone = 0;
      this.currentCountingTaskId = 0;

      results.forEach(result => {
        if (result.CountingTaskStatus == "DONE") {
          this.pollStatus.DONE = this.pollStatus.DONE + 1;
        }
        if (result.CountingTaskStatus == "IN_PROGRESS") {
          this.pollStatus.IN_PROGRESS = 1;
        }
        if (result.CountingTaskStatus == "ON_WAITING") {
          this.pollStatus.ON_WAITING = this.pollStatus.ON_WAITING + 1;
        }

        if (this.inCountingTaskId == result.CountingTaskId) {
          this.currentCountingTaskId = this.currentCountingTaskId + 1;
          if (result.CountingTaskStatus == "DONE") {
            this.currentCountingTaskDone = this.currentCountingTaskDone + 1;
          }
          if (this.id == result.Id) {
            this.showContinueLink = true;
          }
        }
      });

      //controllo se lo scrutinio è finito
      if (this.pollStatus.ON_WAITING == 0 && this.pollStatus.IN_PROGRESS == 0) {
        this.pollStatus.END = true;
      }
    },
    nameLabel() {
      if (
        this.electionType == "UNGROUPED_ONLY_CANDIDATES" ||
        this.electionType == "UNGROUPED_ONLY_CANDIDATES_GROUP_AND_ELECTIONS"
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    //serve per ricaricare i dati se il router chiama lo stesso componente
    $route(to, from) {
      this.getReport();
    }
  },
  components: { PasskeyDialog }
};
</script>
<style scoped>
.scrutinio .md-card {
  max-width: 1200px;
  margin: 0 auto;
}
.myTable {
  font-weight: 500;
  text-align: left;
}

.myTable .md-table-cell {
  font-size: 16px;
}
.back {
  font-weight: bold;
  text-align: left;
  margin-top: -15px;
}

.back a {
  font-weight: bold;
  color: #387a8f;
}

.totalVotes {
  text-align: right;
  font-size: 16px;
  padding: 20px 40px 20px;
}

.tableTotalVotes {
  padding-top: 10px;
  border-top: 1px solid #aaa;
  padding-bottom: 10px;
}

.tableTotalVotes .md-table-cell {
  height: 30px;
}
.md-table.md-theme-default.tableTotalVotes .md-table-row td {
  border: none !important;
}
.md-table.md-theme-default.tableTotalVotes
  .md-table-row:hover:not(.md-header-row)
  .md-table-cell {
  background: #fff;
}

.listTable {
  margin-top: 55px;
}

.button-link {
  color: #387a8f;
  font-size: 14px;
  font-weight: 700;
  text-transform: initial;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #387a8f !important;
  color: #fff !important;
}

.empty {
  font-size: 24px;
  padding: 40px;
  font-style: italic;
  text-align: center;
}

.info {
  background: #fff3cd;
  padding: 25px;
  text-align: left;
  font-size: 18px;
  color: #735602;
  border-radius: 3px;
  border: 1px solid #e6dbba;
  max-width: 1200px;
  margin: 0 auto 20px auto;
  margin-bottom: 0px;
  max-height: 107px;
  display: flex;
}

.info h3 {
  margin: 0;
  display: inline-block;
}

.info span {
  font-style: italic;
}

.info.completed {
  background: #d4edda;
  color: #155724;
  border-color: #c3e6cb;
  max-height: 105px;
  display: flow-root;
}

.info.completed a {
  color: #006494;
  font-weight: bold;
  font-size: 16px;
  float: right;
  margin-top: 4px;
}

a {
  cursor: pointer;
}

.loading {
  width: 33.3%;
}

.percentage {
  text-align: center;
}

.error {
  background: #f8d7da;
  padding: 25px;
  margin-bottom: 20px;
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  margin: 25px 0;
  color: #721c24;
  border-radius: 3px;
  border: 1px solid #f5c6cb;
}

.scrutinio-title {
  margin-top: 16px;
}

.md-progress-bar {
  xheight: 40px;
  xbackground-color: orange;
  margin: 0 auto 20px auto;
  max-width: 1200px;
}
</style>
